import React from 'react'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Switch from '@mui/material/Switch'
import Typography from '@mui/material/Typography'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import CaretDownSvg from '../../assets/images/CaretDown.svg'
import { WhiteOutlineCheckbox } from '../Support/CustomElements'
import { newLabelMapping } from '../../shared/helpers/mappers'

interface ActivityPublicationFieldProps {
    isPublication: boolean
    onIsPublicationChange: (checked: boolean) => void
    publication: Record<string, boolean>
    onPublicationChange: (key: string, checked: boolean) => void
}

const ActivityPublicationField: React.FC<ActivityPublicationFieldProps> = ({
    isPublication,
    onIsPublicationChange,
    publication,
    onPublicationChange,
}) => {
    const [expanded, setExpanded] = React.useState(true)

    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            disableGutters
            elevation={0}
            sx={{ backgroundColor: 'transparent', '&:before': { display: 'none' } }}
        >
            <AccordionSummary
                expandIcon={
                    <Box
                        component="img"
                        src={CaretDownSvg}
                        sx={{
                            width: 20,
                            height: 20,
                            transition: 'transform 0.2s',
                            transform: expanded ? 'rotate(0deg)' : 'rotate(180deg)',
                        }}
                    />
                }
                sx={{
                    px: 0,
                    py: 1,
                    backgroundColor: 'inherit',
                    '& .MuiAccordionSummary-expandIconWrapper': { transform: 'rotate(0deg)' },
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(180deg)' },
                }}
            >
                <Typography variant="18x600" noWrap>
                    Dissemination and Publication
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, pt: 1 }}>
                <FormControl>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isPublication}
                                onChange={(e) => onIsPublicationChange(e.target.checked)}
                                name="isPublication"
                            />
                        }
                        label="Publication"
                    />
                </FormControl>
                {isPublication && (
                    <FormGroup row>
                        {Object.keys(publication).map((pub, i) => {
                            if (pub === 'isPublication') return null
                            return (
                                <FormControlLabel
                                    key={pub + i}
                                    control={
                                        <WhiteOutlineCheckbox
                                            checked={!!publication[pub]}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                onPublicationChange(pub, e.target.checked)
                                            }
                                            color="primary"
                                            name={pub}
                                        />
                                    }
                                    label={newLabelMapping[pub]}
                                />
                            )
                        })}
                    </FormGroup>
                )}
            </AccordionDetails>
        </Accordion>
    )
}

export default ActivityPublicationField
